export default __webpack_public_path__ + "static/media/buddy-invitation.6d13e3cd.png";